module.exports = __webpack_public_path__ + "static/img/block-name.bd13155d.png";